export class BuildDetails {
    buildNumber: string;
}